<template>
<div>
<ContentOverlay ></ContentOverlay>
<div class="content_card" v-if="item">





<div class="grid">




<div class="col-12 md:col-2">

<div class=" show_on_mobile">
<Fieldset :legend="item.name" :toggleable="true" :collapsed="true">
</Fieldset>
</div>



<div class="content_card_content sticky_panel hide_on_mobile">
<h3 class=" text-primary mt-0">{{$filters.sidebartextadjust( item.name)}}</h3>
<hr>

<!-- brand-->
<div class="col-12">
<h4 class="text-primary m-0"><b>{{this.$store.state.languages.lang_phrases.marka}}</b></h4>
</div>
<div class="col-12 mb-2 py-1" >
<small class="p-link" >
  <p class="no-underline text-primary text-sm">{{item.brand.name}}
  </p>
</small>
</div>
<!-- brand-->


</div>



</div>




<div class="col-12 md:col-10">
<div class="content_card_content">
<TabNavigation :tabs="tabs"></TabNavigation>

<router-view></router-view>

</div>
</div>

</div>




</div>
 </div> 
</template>

<script>
export default {

  name: 'SupplierBrand',

  data () {
    return {
    	item:null,
	    tabs: [
			{
				title: 'marka',
				icon: 'list',
				route:'brand'
			},

			{
				title: 'tedarikci_kartlari',
				icon: 'id-card',
				route:'supplier_cards'
			},

			{
				title: 'projeler',
				icon: 'calendar',
				route:'projects'
			},  
	    ],
    }
  },
  async mounted()
  {    
    this.getData()
    this.checkTabName(this.tabs)
    
  },
  methods:{
  	async getData()
  	{
  		this.item = await this.generalApiGet("get_brand_info_for_supplier/"+this.$route.params.supplier_uuid) 
  		await this.$store.dispatch('evaluation/setViewingBrand',this.item.brand)
  		await this.$store.dispatch('suppliers/setSupplier',this.item) 
  		for(let tab of this.tabs)
	    {
	      tab.route = await "/"+this.$store.state.auth.user.uuid+"/supplierbrand/"+this.$route.params.supplier_uuid+"/"+tab.route
	    }
  	},
  }
}
</script>

<style lang="css" scoped>
</style>